import { WHITE_LABELLING_CONTENT } from "@constants/constants";
import { createContext, useContext } from "react";

const WhiteLabellingContext = createContext<WhiteLabellingContent>(WHITE_LABELLING_CONTENT);

export const useWhiteLabellingContent = () => useContext(WhiteLabellingContext);

export default WhiteLabellingContext;
